import clsx from 'clsx'
import React, { InputHTMLAttributes, ReactNode } from 'react'

type InputCheckboxProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string | ReactNode
  error?: string
  showBorderCheckbox?: boolean
  asToggle?: boolean
}

const InputCheckbox = React.forwardRef<HTMLInputElement, InputCheckboxProps>(
  ({ className, label, error, showBorderCheckbox = false, asToggle = false, ...rest }, ref) => {
    const wrapperClasses = clsx('checkbox-wrapper', className)

    const labelClasses = clsx(
      asToggle ? 'toggle-label' : 'checkbox-label',
      showBorderCheckbox && 'show-borders',
      rest.disabled && 'disabled'
    )

    return (
      <div className={wrapperClasses}>
        <label htmlFor={rest.id} className={labelClasses}>
          <input
            type="checkbox"
            ref={ref}
            {...rest}
            className={clsx(asToggle ? 'toggle-input' : 'checkbox-input')}
          />
          {asToggle ? (
            <span className="toggle-slider" />
          ) : (
            <span className="checkbox-case" />
          )}
          {label && <span className="checkbox-text">{label}</span>}
        </label>
        {error && <span className="error">{error}</span>}
      </div>
    )
  }
)

export default InputCheckbox
